import { Toast } from "primereact/toast";
import { useEffect, useRef } from "react";
import { useAppSelector } from "../../stateManagement/hooks/redux";
import { useDispatch } from "react-redux";
import { resetToastMessageSettings, setToastMessageContainerClearButtonIsClicked } from "../../stateManagement/reducers";

interface IToastMessageContainer {
    windowType?: string;
    position?: any;
}

export default function ToastMessageContainer({ windowType, position = 'top-right' }: IToastMessageContainer) {
    const dispatch = useDispatch()
    const { toastMessageIsShown, toastMessageText, toastMessageType, toastMessageWindowType, toastMessageContainerClearButtonIsClicked } = useAppSelector(state => state.toastMessage)
    const toastRef = useRef<any>(null);

    useEffect(() => {
        if (toastRef.current && toastMessageIsShown && toastMessageText && toastMessageType && windowType == toastMessageWindowType) {
            const summary = toastMessageType === "error" ? "Ошибка" : "Уведомление"
            toastRef.current.show({ severity: toastMessageType, summary, detail: toastMessageText, life: 4000 });
            dispatch(resetToastMessageSettings())
        }
    }, [toastMessageIsShown, toastMessageText, toastMessageType, toastMessageWindowType, windowType])

    useEffect(() => {
        if (toastRef.current && toastMessageContainerClearButtonIsClicked) {
            toastRef.current.clear()
            dispatch(setToastMessageContainerClearButtonIsClicked(false))
        }
    }, [toastMessageContainerClearButtonIsClicked])

    return (
        <Toast ref={toastRef} position={position} />
    )
}
